import { render, staticRenderFns } from "./PaymentsExported.vue?vue&type=template&id=c61f8726&scoped=true&"
import script from "./PaymentsExported.vue?vue&type=script&lang=ts&"
export * from "./PaymentsExported.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61f8726",
  null
  
)

export default component.exports